import "@/index.css";
import React from "react";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import ResultPage from "@/pages/ResultPage";
import PreviousResultPage from "@/pages/PreviousResultPage";
import CommonNumberPage from "@/pages/CommonNumberPage";
import Blog from "@/pages/Blog";
import StaticPage from "@/pages/StaticPage";
import { RESULT_PAGES, PREVIOUS_PAGES, COMMON_PAGES, LEGAL_PAGES } from "@/data/pages";
import { Toaster } from "@/components/ui/sonner";

function NotFound() {
  return (
    <div className="max-w-3xl mx-auto px-4 py-24 text-center">
      <h1 className="font-head font-black text-5xl text-[#ff4500] mb-3">404</h1>
      <p className="text-slate-600 mb-6">The page you're looking for could not be found.</p>
      <Link to="/" className="inline-block bg-[#0f172a] text-white font-semibold rounded-full px-6 py-3">
        Back to Home
      </Link>
    </div>
  );
}

// Register a route for both "/path/" and "/path".
function pageRoutes(config, render) {
  const stripped = config.slug.replace(/\/$/, "");
  return [
    <Route key={config.slug} path={config.slug} element={render(config)} />,
    <Route key={stripped} path={stripped} element={render(config)} />,
  ];
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route index element={<Home />} />
            {RESULT_PAGES.flatMap((c) => pageRoutes(c, (cfg) => <ResultPage config={cfg} />))}
            {PREVIOUS_PAGES.flatMap((c) =>
              pageRoutes(c, (cfg) => <PreviousResultPage config={cfg} />)
            )}
            {COMMON_PAGES.flatMap((c) => pageRoutes(c, (cfg) => <CommonNumberPage config={cfg} />))}
            {LEGAL_PAGES.flatMap((c) =>
              pageRoutes(c, (cfg) => <StaticPage slug={cfg.slug} />)
            )}
            <Route path="/blog/" element={<Blog />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}
